import { ListItem } from "@mui/material";

import MultiSelectSearchV3 from "./MultiSelectSearchV3";

export default function ManagedUserFilter({
  selectedItems,
  setSelectedItems,
  setActiveItems,
  activeItems,
  resetPagination,
  setFilterState,
}) {
  const setSelectedState = (selectedValues) => {
    setSelectedItems(selectedValues);
    setFilterState({ fieldName: "managedUserFilter", data: selectedValues });
  };

  return (
    <ListItem>
      <div className="w-full p-2 shadow">
        <MultiSelectSearchV3
          title="Filter by Managed User"
          searchTitle="User Search"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedState}
          setActiveItems={setActiveItems}
          activeItems={activeItems}
          resetPagination={resetPagination}
          nameKey={"name"}
          valueKey={"pk"}
          apiUrl={`/api/users/managed_users/?`}
          buttonFullW={true}
          dropdown={false}
        />
      </div>
    </ListItem>
  );
}
